export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/7e216f4387392f8a5261-recolor.js");
}
